import { checkUser } from '../../sagas/routines/userRoutines';
import { makeStyles } from '@material-ui/core/styles';
import { useDispatch } from 'react-redux';
import CircularProgress from '@material-ui/core/CircularProgress';
import Grid from '@material-ui/core/Grid';
import React, { useEffect, useRef } from 'react';
import Typography from '@material-ui/core/Typography';
const useStyles = makeStyles(theme => ({
    progress: {
        margin: theme.spacing(2),
        marginBottom: theme.spacing(6),
    },
}));

export default function CircularIndeterminate(props) {
    const classes = useStyles();
    const dispatch = useDispatch();
    const pathname = useRef();
    // eslint-disable-next-line react/prop-types
    const { location } = props;
    const handleCheckUser = () => {
        dispatch(checkUser.trigger(pathname.current));
    };
    useEffect(() => {
        if (location && location.state && location.state.from) {
            pathname.current = location.state.from;
        } else {
            pathname.current = '/events' ;
        }
        handleCheckUser();
    }, []);
    return (
        // <Container>
        <Grid
            alignItems="center"
            container
            justify="center"
            style={{
                height: '100%',
                left: 0,
                position: 'absolute',
                top: 0,
            }}
        >
            <Grid item>
                <CircularProgress className={classes.progress} color="secondary" />
                <Typography variant="h2">Loading...</Typography>
            </Grid>
        </Grid>
        // </Container>
    );
}
